import { BaseTextMergeContainerElement } from "../BaseTextMergeContainerElement";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { TextMergeType } from "../../TextMergeType";
import { StateManager } from "../../../Common/StateManager";

export class StyleElement extends BaseTextMergeContainerElement {
    readonly __type = "style";
    readonly name = "Style Element";
    readonly styleElement: boolean = true;
    readonly ordinal: number = 2;

    private _newParagraph: boolean = false;

    get newParagraph(): boolean {
        return this._newParagraph;
    }

    set newParagraph(value: boolean) {
        this._newParagraph = value;
        StateManager.propertyChanged(this, "newParagraph");
    }

    getHTMLTag(): string {
        if (this._newParagraph === false) return "span";
        else return "p";
    }

    canAdd(config: TextMergeConfiguration): boolean {
        return config.type === TextMergeType.HTML;
    }

    override getStorageData(): object {
        let d = super.getStorageData();

        this._newParagraph = Reflect.get(d, "newParagraph");

        return d;
    }

    override setStorageData(d: object) {
        super.setStorageData(d);

        Reflect.set(d, "newParagraph", this._newParagraph);
    }
}
